/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_H2_EmInputs */

const es_landing_law_h2_em = /** @type {(inputs: Landing_Law_H2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alquilarse.`)
};

const gl_landing_law_h2_em = /** @type {(inputs: Landing_Law_H2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alugarse.`)
};

const en_landing_law_h2_em = /** @type {(inputs: Landing_Law_H2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rented out.`)
};

/**
* | output |
* | --- |
* | "rented out." |
*
* @param {Landing_Law_H2_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_h2_em = /** @type {((inputs?: Landing_Law_H2_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_H2_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_h2_em(inputs)
	if (locale === "en") return en_landing_law_h2_em(inputs)
	return es_landing_law_h2_em(inputs)
});